import React, { useEffect, useState } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Loader, AlertCircle, CheckCircle } from 'lucide-react';
import api from '../services/api';
import Seo from '../components/Seo';

// The page behind the link in the signup email: confirms the address, or offers a new link.
export default function VerifyEmailPage() {
  const [params] = useSearchParams();
  const token = params.get('token');
  const [state, setState] = useState(token ? 'working' : 'error');
  const [message, setMessage] = useState(token ? '' : 'This confirmation link is missing its token.');
  const [email, setEmail] = useState('');
  const [resent, setResent] = useState(false);

  useEffect(() => {
    if (!token) return;
    api.post('/auth/verify-email', { token })
      .then((r) => { setState('done'); setMessage(r.data.message || 'Email confirmed.'); })
      .catch((e) => { setState('error'); setMessage(e.response?.data?.error || 'Could not confirm your email.'); });
  }, [token]);

  const resend = async () => {
    try { await api.post('/auth/resend-verification', { email }); } finally { setResent(true); }
  };

  return (
    <div className="min-h-[100dvh] flex items-center justify-center bg-[#F3F3F3] px-4 py-8">
      <Seo title="Confirm your email" />
      <div className="w-full max-w-md bg-white border border-[#E5E5E5] rounded-lg p-6 sm:p-8 text-center space-y-4 shadow-[0_1px_3px_rgba(0,0,0,0.08)]">
        {state === 'working' && <><Loader className="mx-auto animate-spin text-[#0176D3]" size={36} /><p className="text-sm text-[#706E6B]">Confirming your email…</p></>}
        {state === 'done' && (<>
          <CheckCircle className="mx-auto text-[#2E844A]" size={44} />
          <h2 className="text-xl font-bold text-[#080707]">Email confirmed</h2>
          <p className="text-sm text-[#706E6B]">{message}</p>
          <Link to="/login" className="inline-flex h-9 items-center justify-center bg-[#0176D3] text-white rounded text-[13px] font-semibold px-4">Sign in</Link>
        </>)}
        {state === 'error' && (<>
          <AlertCircle className="mx-auto text-[#BA0517]" size={44} />
          <h2 className="text-xl font-bold text-[#080707]">We could not confirm this link</h2>
          <p className="text-sm text-[#706E6B]">{message}</p>
          {resent ? <p className="text-sm text-[#2E844A]">If that account needs confirming, we sent a new link.</p> : (
            <div className="space-y-2">
              <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Your email" className="w-full border border-[#D8DDE6] rounded-[4px] px-3 py-2 text-[13px]" />
              <button onClick={resend} disabled={!email.includes('@')} className="w-full h-9 bg-[#0176D3] disabled:opacity-50 text-white rounded text-[13px] font-semibold">Send a new link</button>
            </div>
          )}
        </>)}
      </div>
    </div>
  );
}
